import styled from 'styled-components';
import { Body2Styles } from '../typography';
import { getSizeBy, getColor, getColorShade, getThemeProp, getHintColor } from '../../../src/styled/utils';
export const StyledTextareaInput = styled.textarea `
  ${Body2Styles};
  position: relative;
  display: block;
  width: 100%;
  padding: ${({ $sizeTextarea }) => {
    if ($sizeTextarea === 'small')
        return [getSizeBy(1), ' ', getSizeBy(3)];
    if ($sizeTextarea === 'medium')
        return [getSizeBy(2), ' ', getSizeBy(3)];
    return [getSizeBy(3), ' ', getSizeBy(3)];
}};
  overflow: hidden;
  color: ${({ disabled }) => {
    if (disabled) {
        return getColorShade('onSurface', 'lowEmphasis');
    }
    return getColor('onSurface');
}};
  background: ${({ disabled }) => disabled ? getColorShade('onSurface', 'hover') : getColor('surface')};
  border-color: ${({ $hintType, $inputLength }) => {
    if ($hintType && $inputLength && $inputLength > 0)
        return getHintColor($hintType);
    return getColorShade('onSurface', 'outline');
}};
  border-style: solid;
  border-width: 1px;
  border-radius: ${getThemeProp('borderRadius')}px;
  resize: ${({ $resize }) => $resize};

  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  &::-webkit-resizer {
    background-image: linear-gradient(
      -45deg,
      ${getColorShade('onSurface', 'lowEmphasis')} 50%,
      ${getColor('surface')} 50%
    );
    background-repeat: no-repeat;
    background-position: right bottom;
    background-size: 9px 9px;
    border-radius: 0 0 ${getSizeBy()} 0;
    box-shadow: inset -1px -1px ${getColor('surface')};
  }

  &::-webkit-scrollbar {
    width: 8px;
    border-radius: ${getSizeBy(1.5)};
  }

  &::-webkit-scrollbar-track {
    margin-top: 1px;
    margin-bottom: 1px;
    background-color: ${getColorShade('onSurface', 'outline')};
    border-radius: 6px;
    box-shadow: inset 0 0 0 2px ${getColor('surface')};
  }

  &::-webkit-scrollbar-thumb {
    background-image: linear-gradient(
      to right,
      ${getColor('surface')} 25%,
      ${getColorShade('onSurface', 'lowEmphasis')} 25%,
      ${getColorShade('onSurface', 'lowEmphasis')} 75%,
      ${getColor('surface')} 75%
    );
    border-radius: 6px;
  }

  &:hover {
    border-color: ${({ $hintType, disabled, $hasConsistentBorder }) => {
    if (!disabled && $hasConsistentBorder) {
        return getHintColor($hintType);
    }
    else if (!disabled && !$hasConsistentBorder) {
        return getColorShade('onSurface', 'lowEmphasis');
    }
}};
    border-style: solid;
    border-width: 1px;
  }

  &:focus {
    border-color: ${({ $hasConsistentBorder, $hintType }) => $hasConsistentBorder ? getHintColor($hintType) : getColor('primary')};
    border-style: solid;
    border-width: 1px;
    outline: none;
  }

  &::placeholder {
    color: ${getColorShade('onSurface', 'lowEmphasis')};
  }
`;
export const HintWrapper = styled.span `
  ${Body2Styles};
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  color: ${getColorShade('onSurface', 'mediumEmphasis')};
  font-weight: normal;
  font-size: ${getSizeBy(3)};
  line-height: ${getSizeBy(4)};

  span {
    margin-left: ${getSizeBy(2)};
  }
`;
export const WrapLabel = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const CounterSpan = styled.span `
  ${Body2Styles};
  color: ${({ $isValid, $isTouched, $inputLength }) => {
    if ($inputLength && $inputLength > 0 && $isValid) {
        return getColor('success');
    }
    if ($inputLength && $inputLength > 0 && !$isValid) {
        return getColor('danger');
    }
    if (!$inputLength && $isTouched && !$isValid) {
        return getColor('danger');
    }
    return getColorShade('onSurface', 'mediumEmphasis');
}};
  font-weight: normal;
  font-size: ${getSizeBy(3)};
  line-height: ${getSizeBy(4)};
  white-space: pre;
`;
